<template>
  <div class="page_content strm_time_view" aria-label="Stream Time view content page">
    <div class="row page-heading">
      <div class="col-7 input module_heading" :class="[showEntity ? 'entity-heading' : '']">
        <span class="module_icon icon-stream"></span>
        <label class="head_txt module_type_name stream-title ace_sec_hd" role="heading" :aria-label="stream.title"><span v-if="advisorTitle">{{advisorTitle}}: </span>{{stream.title}}</label>
        <label class="head_txt module_type_name ace_sec_hd" v-if="showEntity" role="heading" :aria-label="entity.title"> <span class="separator">::</span> {{entity.title}}</label>
      </div>
      <div class="col-5 right-container">
        <stream-header :uuid="uuid" :cip-code="cipCode" :return-to="returnTo" active="category"></stream-header>
      </div>
    </div>
    <div class="page-content">
      <stream-menu :uuid="uuid" active="time"></stream-menu>
      <div class="col-12 dasboard-left-section">
        <div class="stream-view-section">
          <div class="row">
            <div class="table-of-content-column ace_sec" aria-label="Stream TOC Section" style="width: 500px;">
              <div class="table-header">
                <span class="list-icon icon-list"></span>
                <span class="title ace_sec_txt" @click ="loadStream" :aria-label="stream.title" :title="stream.title">{{stream.title}}</span>
              </div>
              <div class="toc_tree_panel">
                <ul class="toc_container">
                  <node-tree :node="substream" :isCategoryView="false" :isOwner="isOwner" v-for="substream in structure"></node-tree>
                </ul>
              </div>
            </div>
            <template v-if="!showEntity">
              <div class="thumbnail_panel ace_sec">
                <div class="thumbnail_container ace_sec_txt" aria-label="default image">
                  <div class="default">
                    <div class="thumbnail">
                      <div class="thumbnail_icon icon-stream"></div>
                    </div>
                  </div>
                  <div class="entity-row">
                    <!--
                    <div class="entity-column">
                      <span class="icon-course icon"></span>
                      <span class="entity-value">1</span>
                    </div>
                    <div class="more-link">more</div>
                    -->
                  </div>
                </div>
                <div class="content-row ace_sec_txt" :aria-label="'Stream Created By ' + stream.ownerName">
                  <div class="heading">Stream Created By</div>
                  <div class="result-value">{{stream.ownerName}}</div>
                </div>
                <!--
                  <div class="content-row extract-info">
                    <div class="heading">
                      <span class="icon-extract"></span>
                      <span class="tag-heading ">Extracted Info</span>
                    </div>
                    <div class="result-value">
                      <div class="tags">
                        <span class="tag">watson</span>
                      </div>
                      <div class="tags">
                        <span class="tag">watson 17th</span>
                      </div>
                    </div>
                  </div>
                                         -->
                <div class="content-row general-tag" v-if="isTagsAvailable">
                  <div class="heading">
                    <span class="ic-tag"></span>
                    <span class="tag-heading ace_sec_txt" aria-label="Tags">Tags</span>
                  </div>
                  <div class="result-value tags_container">
                    <template v-for="(values, key, i) in stream.appliedTagMap">
                      <div class="tag ace_sec_txt" v-for="(tag, j) in values">
                        <span class="tag_name instructional_tag" :aria-label="tag.name">{{tag.name}}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="description-column" style="width: calc(100% - 800px);">
                <div class="page-section">
                  <template v-if="advisorName">
                    <div class="page_section_row">
                      <div class="heading">
                        <label role="heading" aria-label="Advisor" tabindex="0">Advisor</label>
                      </div>
                      <div class="page_content_block" :aria-label="advisorName" tabindex="0">
                        {{advisorName}}
                      </div>
                    </div>
                  </template>
                  <template v-if="specialNotes.length > 0" v-for="specialNote in specialNotes">
                    <div class="page_section_row">
                      <div class="heading">
                        <label class="ace_sec_hd" role="heading" :aria-label="specialNote.title">{{specialNote.title}}</label>
                      </div>
                      <div class="page_content_block ace_sec_txt">
                        Required {{specialNote.required}}/ Used {{specialNote.used}}/ Needed {{specialNote.needed}}
                      </div>
                    </div>
                  </template>
                  <template v-if="stream.description">
                    <div class="page_section_row">
                      <div class="heading">
                        <label class="ace_sec_hd" role="heading" aria-label="Description">Description</label>
                      </div>
                      <div class="page_content_block">
                        <div class="courseDesc ace_sec_txt" :aria-label="stream.description" v-html="stream.description"></div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </template>
            <template v-if="showEntity">
              <div class="thumbnail_panel">
                <div class="thumbnail_container ace_sec" aria-label="Thumbnail Section">
                  <template v-if="entity.thumbnail">
                    <div class="thumbnail_icon">
                      <img :src="entity.thumbnail">
                    </div>
                  </template>
                  <template v-else>
                    <div class="default">
                      <div class="thumbnail">
                        <div class="thumbnail_icon icon-course" v-if="entity.entityType === 'deliverycontext'"></div>
                        <div class="thumbnail_icon ic-catalog" v-if="entity.entityType === 'catalog'"></div>
                        <div class="thumbnail_icon icon-job" v-if="entity.entityType === 'job'"></div>
                        <div class="thumbnail_icon icon-event" v-if="entity.entityType === 'event'"></div>
                        <div class="thumbnail_icon icon-club" v-if="entity.entityType === 'club'"></div>
                      </div>
                    </div>
                  </template>
                  <div class="entity-row">
                    <!--
                      <div class="entity-column">
                        <span class="icon-course icon"></span>
                        <span class="entity-value">1</span>
                      </div>
                      <div class="more-link">more</div>
                               -->
                  </div>
                </div>
                <div class="content-row ace_sec_txt" v-if="instructorName" :aria-label="'Instructor ' + instructorName">
                  <div class="heading">Instructor</div>
                  <div class="result-value" :aria-label="instructorName">{{instructorName}}</div>
                </div>
                <div class="content-row ace_sec_txt" v-if="entity.roomInformation" :aria-label="'Location ' + entity.roomInformation">
                  <div class="heading">Location</div>
                  <div class="result-value">{{entity.roomInformation}}</div>
                </div>
                <div class="content-row ace_sec_txt" v-if="meetingDays" :aria-label="'Meeting Days ' + meetingDays">
                  <div class="heading">Meeting Days</div>
                  <div class="result-value">{{meetingDays}}</div>
                </div>
                <div class="content-row ace_sec_txt" v-if="meetingTimes" :aria-label="'Meeting Times ' + meetingTimes">
                  <div class="heading">Meeting Times</div>
                  <div class="result-value">{{meetingTimes}}</div>
                </div>
                <div class="content-row ace_sec_txt" v-if="crn" :aria-label="'CRN ' + crn">
                  <div class="heading">CRN</div>
                  <div class="result-value">{{crn}}</div>
                </div>
                <div class="content-row ace_sec_txt" v-if="section" :aria-label="'Section ' + section">
                  <div class="heading">Section #</div>
                  <div class="result-value">{{section}}</div>
                </div>
              </div>
              <div class="description-column">
                <div class="page-section">
                  <template v-if="entity.description">
                    <div class="page_section_row">
                      <div class="heading">
                        <label class="ace_sec_hd" role="heading" aria-label="Description">Description</label>
                      </div>
                      <div class="page_content_block">
                        <div class="courseDesc ace_sec_txt" :aria-label="entity.description" v-html="entity.description"></div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
  import '../../../assets/module/css/stream/streamView.min.css'
  import { mapState, mapActions } from 'vuex'
  import StreamMenu from './StreamMenu'
  import StreamHeader from './StreamHeader'
  import NodeTree from './NodeTree'
  
  export default {
    name: 'streamTime',
    props: ['uuid', 'cipCode', 'returnTo'],
    components: {
      StreamMenu,
      NodeTree,
      StreamHeader
    },
    data: () => {
      return {
        uObj: JSON.parse(localStorage.getItem('userobj')),
        userrole: localStorage.getItem('userrole'),
        userId: localStorage.getItem('userid'),
        specialNotes: []
      }
    },
    mounted () {
      this.loadStream()
    },
    methods: {
      ...mapActions([
        'loadStreamDetail',
        'loadUserAdvisor',
        'loadLogDashboardActivity',
        'loadStudentSpecialNotes'
      ]),
  
      async loadStream () {
        this.$refs.loadingModal.show()
        this.loadLogDashboardActivity({action: 'viewStreamTimeView', page: 'streamTimeView', link: '', entityUuid: this.uuid})
        await this.loadStreamDetail(this.uuid)
        await this.loadUserAdvisor(this.stream.ownerId)
        this.specialNotes = await this.loadStudentSpecialNotes()
        if (this.stream.uuid) {
          this.$refs.loadingModal.hide()
        }
      }
    },
    computed: {
      ...mapState({
        'stream': state => state.stream.stream,
        'entity': state => state.stream.entity,
        'showEntity': state => state.stream.showEntity,
        'advisor': state => state.user.advisor
      }),
      isOwner () {
        return (this.userId === this.stream.ownerId)
      },
      structure () {
        if (this.stream && this.stream.structure) {
          return JSON.parse(this.stream.structure)
        } else {
          return []
        }
      },
      major () {
        if (this.uObj && this.uObj.major1Title) {
          return this.uObj.major1Title
        }
        return ''
      },
      isTagsAvailable () {
        if (this.stream.appliedTagMap) {
          let values = Object.values(this.stream.appliedTagMap)
          return values.find((value) => {
            return value.length > 0
          })
        }
        return false
      },
      advisorName () {
        if (this.advisor) {
          return this.advisor.name
        } else {
          return null
        }
      },
      instructorName () {
        if (this.entity.instructorNames) {
          var str = this.entity.instructorNames[0]
          var res = str.split('__')
          var instNames = res[0]
          for (var i = 1; i < this.entity.instructorNames.length; i++) {
            str = this.entity.instructorNames[i]
            res = str.split('__')
            instNames = instNames + ', ' + res[0]
          }
          return instNames
        } else {
          return ''
        }
      },
      meetingDays () {
        var meetingDays = ''
        if (this.entity.meetingDaysRaw && this.entity.meetingDaysRaw.length > 0) {
          meetingDays = meetingDays + this.entity.meetingDaysRaw[0].day
        }
  
        if (this.entity.meetingDaysRaw && this.entity.meetingDaysRaw.length > 1) {
          meetingDays = meetingDays + ', ' + this.entity.meetingDaysRaw[1].day
        }
        return meetingDays
      },
      meetingTimes () {
        var meetingTimes = ''
        if (this.entity.meetingDaysRaw && this.entity.meetingDaysRaw.length > 0) {
          if (this.entity.meetingDaysRaw[0].meetingFromTime !== null && this.entity.meetingDaysRaw[0].meetingToTime !== null) {
            meetingTimes = meetingTimes + this.entity.meetingDaysRaw[0].meetingFromTime + '-' + this.entity.meetingDaysRaw[0].meetingToTime
          }
        }
  
        if (this.entity.meetingDaysRaw && this.entity.meetingDaysRaw.length > 1) {
          if (this.entity.meetingDaysRaw[1].meetingFromTime !== null && this.entity.meetingDaysRaw[1].meetingToTime !== null) {
            meetingTimes = meetingTimes + ', ' + this.entity.meetingDaysRaw[1].meetingFromTime + '-' + this.entity.meetingDaysRaw[1].meetingToTime
          }
        }
        return meetingTimes
      },
  
      crn () {
        if (this.entity.crn) {
          return this.entity.crn
        } else {
          return ''
        }
      },
  
      section () {
        if (this.entity.num) {
          return this.entity.num
        } else {
          return ''
        }
      },
      advisorTitle () {
        if (this.userrole === 'Advisor' && this.stream && this.stream.ownerName) {
          return '' + this.stream.ownerName + ''
        } else {
          return ''
        }
      }
    }
  }
</script>
<style>
  .margin-top-10 {
    margin-top: 10px;
  }
  .margin-top-20 {
    margin-top: 20px;
  }
  .margin-top-30 {
    margin-top: 30px;
  }
  .no-border {
    border: none;
  }
  .margin-left-20 {
    margin-left: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/app/stream/components/StreamTime.vue